// React bootstrap table next =>
// DOCS: https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/
// STORYBOOK: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/products/productsActions";
import * as uiHelpers from "../ProductsUIHelpers";
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
} from "../../../../../../_metronic/_helpers";

import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useProductsUIContext } from "../ProductsUIContext";
import { NavLink } from "react-router-dom";
import CsvDownload from "react-json-to-csv";
import { MoneyFormatter } from "../../../../formatters/CustomFormatters";
import { DateFormatter } from "../../../../formatters/CustomFormatters";

export function ProductsTable() {
  // Products UI Context
  const productsUIContext = useProductsUIContext();
  const productsUIProps = useMemo(() => {
    return {
      ids: productsUIContext.ids,
      setIds: productsUIContext.setIds,
      queryParams: productsUIContext.queryParams,
      setQueryParams: productsUIContext.setQueryParams,
      openEditProductPage: productsUIContext.openEditProductPage,
      openDeleteProductDialog: productsUIContext.openDeleteProductDialog,
    };
  }, [productsUIContext]);

  // Getting curret state of products list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.products }),
    shallowEqual
  );
  const { totalCount, entities, listLoading, error } = currentState;
  // Products Redux state
  const dispatch = useDispatch();
  useEffect(() => {
    // clear selections list
    productsUIProps.setIds([]);
    // server call by queryParams
    dispatch(actions.fetchProducts(productsUIProps.queryParams));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsUIProps.queryParams, dispatch]);
  // Table columns
  const columns = [
    {
      dataField: "customerTaxId",
      text: "Tax Id",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "duns",
      text: "Duns",
      sort: false,
      sortCaret: sortCaret,
    },
    {
      dataField: "customerCode",
      text: "Account system customer Code",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "customerName",
      text: "customer Name",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "date",
      text: "Date",

      formatter: DateFormatter,
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "sum",
      text: "Amount",
      sort: true,
      formatter: MoneyFormatter,
    },
    {
      dataField: "daysUntilPaymentDay",
      text: "days to due date",
      sort: true,
      //  formatter: columnFormatters.PriceColumnFormatter,
    },
    {
      dataField: "paymentDelay",
      text: "past due (days)",
      sort: true,
      //  formatter: columnFormatters.PriceColumnFormatter,
    },

    {
      dataField: "closingNdays",
      text: "closed n days",
      sort: true,
      //  formatter: columnFormatters.PriceColumnFormatter,
    },
  ];
  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: productsUIProps.queryParams.pageSize,
    page: productsUIProps.queryParams.pageNumber,
  };

  if (error == 10) {
    return (
      <div className="card-body pt-2 pb-0">
        <span style={{ color: "red" }}>
          This data is blocked because Some of your customers require Tax Id
        </span>

        <NavLink className="menu-link menu-toggle" to="/customers">
          <span className="menu-text">
            {" "}
            Please update your Customer details
          </span>
        </NavLink>
      </div>
    );
  } else {
    return (
      <>
        <CsvDownload
          type="button"
          className="btn btn-primary float-right"
          data={entities}
        >
          Export
        </CsvDownload>
        <PaginationProvider pagination={paginationFactory(paginationOptions)}>
          {({ paginationProps, paginationTableProps }) => {
            return (
              <Pagination
                isLoading={listLoading}
                paginationProps={paginationProps}
              >
                <BootstrapTable
                  wrapperClasses="table-responsive"
                  classes="table table-head-custom table-vertical-center overflow-hidden"
                  bootstrap4
                  bordered={false}
                  remote
                  keyField="_id"
                  data={entities === null ? [] : entities}
                  columns={columns}
                  defaultSorted={uiHelpers.defaultSorted}
                  onTableChange={getHandlerTableChange(
                    productsUIProps.setQueryParams
                  )}
                  {...paginationTableProps}
                >
                  <PleaseWaitMessage entities={entities} />
                  <NoRecordsFoundMessage entities={entities} />
                </BootstrapTable>
              </Pagination>
            );
          }}
        </PaginationProvider>
      </>
    );
  }
}
